/* FAIR — Bundle Builder Logic v8. Pick N (driven by section setting data-bundle-size) + per-item quantity + variants + Size Guide + carousel + cart drawer. */
(function () {
  'use strict';

  let BUNDLE_SIZE = 6;   // overridden at boot from [data-fbb-root][data-bundle-size]
  let DISCOUNT_PCT = 70; // overridden at boot from [data-fbb-root][data-discount-pct]
  const STORAGE_KEY = 'fair_bundle_selection_v2';
  const SELECTED_CLASS = 'is-selected';
  const LOCKED_CLASS = 'is-locked';
  const HAS_VARIANT_CLASS = 'has-variant';

  const SIZE_GUIDE_CONTENT = {
    necklace: {
      title: 'Necklace size guide',
      sub: 'Find the length that sits where you want it.',
      html: ''
        + '<img class="fbb-modal__image" src="https://cdn.shopify.com/s/files/1/0703/8759/7427/files/chain-sizes-frontal.webp?v=1780025320" alt="Chain lengths from 18 inches to 26 inches shown on a model" loading="lazy">'
        + '<img class="fbb-modal__image" src="https://cdn.shopify.com/s/files/1/0703/8759/7427/files/chain-sizes-comparison.webp?v=1780025304" alt="18, 20, 22, 24, and 26 inch chains side by side" loading="lazy">'
        + '<div class="fbb-modal__stats">'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">Model height</div><div class="fbb-modal__stat-value">5\'11&quot;</div></div>'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">Model collar</div><div class="fbb-modal__stat-value">15.5&quot;</div></div>'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">Most picked</div><div class="fbb-modal__stat-value"><strong>20&quot;</strong></div></div>'
        + '</div>'
        + '<p>The right chain length is personal. Use the photos above to decide how you want your chain to sit — high on the collarbone, on the sternum, or lower on the chest.</p>'
        + '<div class="fbb-modal__tip"><p><strong>Not sure?</strong> Go with 20\". It\'s the most popular length for a reason — sits cleanly on a crew neck tee and layers well.</p></div>'
    },
    bracelet: {
      title: 'Bracelet size guide',
      sub: 'Measure once, get it right.',
      html: ''
        + '<p>Bracelet sizes are listed as <strong>circumference in inches</strong>.</p>'
        + '<p><strong>To measure your wrist:</strong> wrap a piece of string or paper around your wrist, mark or cut where it joins, then measure against a ruler in inches. In between sizes? Always opt for the larger size.</p>'
        + '<div class="fbb-modal__stats">'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">In between sizes?</div><div class="fbb-modal__stat-value"><strong>Size up</strong></div></div>'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">One size fits all</div><div class="fbb-modal__stat-value">7.5&quot; – 8.5&quot;</div></div>'
        + '</div>'
        + '<p><strong>Beaded and leather bracelets:</strong> some are marked &quot;one size fits all&quot; — designed to fit all wrists from 7.5&quot; to 8.5&quot;.</p>'
        + '<div class="fbb-modal__tip"><p><strong>Rule of thumb:</strong> when you\'re between two sizes, pick the larger one. Bracelets that sit slightly loose look better and are more comfortable.</p></div>'
    }
  };

  class BundleBuilder {
    constructor(root) {
      this.root = root;
      this.selection = [];
      this.pendingVariants = {};

      this.grid = root.querySelector('[data-fbb-grid]');
      this.progress = document.querySelector('[data-fbb-progress]');
      this.tray = document.querySelector('[data-fbb-tray]');
      this.toast = document.querySelector('[data-fbb-toast]');

      this.countEl = this.progress && this.progress.querySelector('[data-fbb-count]');
      this.barFillEl = this.progress && this.progress.querySelector('[data-fbb-bar-fill]');
      this.amountOriginalEl = this.progress && this.progress.querySelector('[data-fbb-amount-original]');
      this.amountFinalEl = this.progress && this.progress.querySelector('[data-fbb-amount-final]');
      this.amountSavedEl = this.progress && this.progress.querySelector('[data-fbb-amount-saved]');
      this.ctaEl = this.progress && this.progress.querySelector('[data-fbb-cta]');
      this.toggleEl = this.progress && this.progress.querySelector('[data-fbb-toggle]');
      this.trayInnerEl = this.tray && this.tray.querySelector('[data-fbb-tray-inner]');

      this.filterPills = root.querySelectorAll('[data-fbb-filter]');
      this.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

      this.modalEl = null;
      this.modalDialogEl = null;
      this.modalTitleEl = null;
      this.modalSubEl = null;
      this.modalBodyEl = null;

      this.init();
    }

    init() {
      this.loadFromStorage();
      this.buildModal();
      this.bindEvents();
      this.initCarousels();
      this.render();
      const self = this;
      requestAnimationFrame(function () {
        if (self.progress) self.progress.classList.add('is-visible');
      });
    }

    initCarousels() {
      if (!this.grid) return;
      const slidesEls = this.grid.querySelectorAll('[data-fbb-slides]');
      slidesEls.forEach(function (slides) {
        const parent = slides.parentElement;
        const dotsEl = parent ? parent.querySelector('[data-fbb-dots]') : null;
        if (!dotsEl) return;
        const dots = dotsEl.querySelectorAll('.fbb-card__dot');
        if (dots.length < 2) return;
        let ticking = false;
        slides.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            const w = slides.clientWidth || 1;
            const idx = Math.round(slides.scrollLeft / w);
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
            ticking = false;
          });
        }, { passive: true });
      });
    }

    buildModal() {
      const modal = document.createElement('div');
      modal.className = 'fbb-modal';
      modal.setAttribute('data-fbb-modal', '');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'fbb-modal-title');
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = ''
        + '<div class="fbb-modal__overlay" data-fbb-modal-close></div>'
        + '<div class="fbb-modal__dialog" role="document">'
        +   '<button type="button" class="fbb-modal__close" data-fbb-modal-close aria-label="Close size guide">✕</button>'
        +   '<div class="fbb-modal__header">'
        +     '<h2 class="fbb-modal__title" id="fbb-modal-title" data-fbb-modal-title></h2>'
        +     '<p class="fbb-modal__sub" data-fbb-modal-sub></p>'
        +   '</div>'
        +   '<div class="fbb-modal__body" data-fbb-modal-body></div>'
        + '</div>';
      document.body.appendChild(modal);

      this.modalEl = modal;
      this.modalDialogEl = modal.querySelector('.fbb-modal__dialog');
      this.modalTitleEl = modal.querySelector('[data-fbb-modal-title]');
      this.modalSubEl = modal.querySelector('[data-fbb-modal-sub]');
      this.modalBodyEl = modal.querySelector('[data-fbb-modal-body]');
    }

    openSizeGuide(guideType) {
      const content = SIZE_GUIDE_CONTENT[guideType] || SIZE_GUIDE_CONTENT.bracelet;
      this.modalTitleEl.textContent = content.title;
      this.modalSubEl.textContent = content.sub;
      this.modalBodyEl.innerHTML = content.html;
      this.modalEl.classList.add('is-open');
      this.modalEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (this.modalDialogEl) this.modalDialogEl.scrollTop = 0;
    }

    closeSizeGuide() {
      this.modalEl.classList.remove('is-open');
      this.modalEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    loadFromStorage() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        const data = JSON.parse(raw);
        if (Array.isArray(data)) this.selection = data.slice(0, BUNDLE_SIZE);
      } catch (e) { this.selection = []; }
    }

    saveToStorage() {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.selection)); } catch (e) {}
    }

    /* ===== Quantity helpers ===== */
    getQty(productId) {
      let n = 0;
      for (let i = 0; i < this.selection.length; i++) {
        if (this.selection[i].productId === productId) n++;
      }
      return n;
    }

    addUnit(card) {
      if (this.selection.length >= BUNDLE_SIZE) {
        this.showToast('Max ' + BUNDLE_SIZE + ' pieces. Remove one to add another.', 'warning');
        return;
      }
      const productId = card.dataset.productId;
      const needsPick = card.dataset.needsPick === 'true';

      let variantId, price;
      if (needsPick) {
        const pending = this.pendingVariants[productId];
        if (pending) {
          variantId = pending.variantId;
          price = pending.price;
        } else {
          const existing = this.selection.find(function (i) { return i.productId === productId; });
          if (existing) {
            variantId = existing.variantId;
            price = existing.price;
          } else {
            this.showToast('Pick a size first.', 'warning');
            return;
          }
        }
      } else {
        variantId = card.dataset.defaultVariantId;
        price = parseInt(card.dataset.defaultPrice, 10);
      }

      this.selection.push({
        variantId: variantId,
        productId: productId,
        price: price,
        image: card.dataset.image,
        title: card.dataset.title,
        handle: card.dataset.handle
      });
      this.saveToStorage();
      this.render();
    }

    removeUnit(productId) {
      let idx = -1;
      for (let i = this.selection.length - 1; i >= 0; i--) {
        if (this.selection[i].productId === productId) { idx = i; break; }
      }
      if (idx >= 0) {
        this.selection.splice(idx, 1);
        this.saveToStorage();
        this.render();
      }
    }

    removeOneByVariantId(variantId) {
      let idx = -1;
      for (let i = this.selection.length - 1; i >= 0; i--) {
        if (this.selection[i].variantId === variantId) { idx = i; break; }
      }
      if (idx >= 0) {
        this.selection.splice(idx, 1);
        this.saveToStorage();
        this.render();
      }
    }

    bindEvents() {
      const self = this;
      if (this.grid) {
        this.grid.addEventListener('click', function (e) {
          const guideBtn = e.target.closest('[data-fbb-size-guide]');
          if (guideBtn) {
            e.preventDefault();
            e.stopPropagation();
            self.openSizeGuide(guideBtn.dataset.guideType || 'bracelet');
            return;
          }
          const pill = e.target.closest('[data-fbb-variant]');
          if (pill && !pill.disabled) {
            e.preventDefault();
            self.pickVariant(pill);
            return;
          }
          const minus = e.target.closest('[data-fbb-qty-minus]');
          if (minus) {
            e.preventDefault();
            const card = minus.closest('[data-fbb-card]');
            if (card) self.removeUnit(card.dataset.productId);
            return;
          }
          const plus = e.target.closest('[data-fbb-qty-plus]');
          if (plus && !plus.disabled) {
            e.preventDefault();
            const card = plus.closest('[data-fbb-card]');
            if (card) self.addUnit(card);
            return;
          }
          const action = e.target.closest('[data-fbb-action]');
          if (action && !action.disabled) {
            e.preventDefault();
            const card = action.closest('[data-fbb-card]');
            if (card) self.addUnit(card);
          }
        });
      }
      if (this.modalEl) {
        this.modalEl.addEventListener('click', function (e) {
          if (e.target.closest('[data-fbb-modal-close]')) {
            self.closeSizeGuide();
          }
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modalEl && self.modalEl.classList.contains('is-open')) {
          self.closeSizeGuide();
        }
      });
      if (this.ctaEl) {
        this.ctaEl.addEventListener('click', function () {
          if (self.selection.length === BUNDLE_SIZE) self.addAllToCart();
        });
      }
      if (this.toggleEl) {
        this.toggleEl.addEventListener('click', function () {
          if (self.tray) self.tray.classList.toggle('is-open');
        });
      }
      if (this.tray) {
        this.tray.addEventListener('click', function (e) {
          const removeBtn = e.target.closest('[data-fbb-tray-remove]');
          if (!removeBtn) return;
          self.removeOneByVariantId(removeBtn.dataset.variantId);
        });
      }
      this.filterPills.forEach(function (pill) {
        pill.addEventListener('click', function () { self.applyFilter(pill); });
      });
    }

    pickVariant(pill) {
      const card = pill.closest('[data-fbb-card]');
      if (!card) return;
      const productId = card.dataset.productId;
      const variantId = pill.dataset.variantId;
      const variantPrice = parseInt(pill.dataset.variantPrice, 10);

      this.pendingVariants[productId] = { variantId: variantId, price: variantPrice };

      const allPills = card.querySelectorAll('[data-fbb-variant]');
      allPills.forEach(function (p) {
        const active = p === pill;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      card.classList.add(HAS_VARIANT_CLASS);
      const action = card.querySelector('[data-fbb-action]');
      if (action) action.disabled = false;

      const priceEl = card.querySelector('[data-fbb-price]');
      if (priceEl) priceEl.textContent = this.formatMoney(variantPrice);

      let changed = false;
      this.selection.forEach(function (i) {
        if (i.productId === productId) {
          i.variantId = variantId;
          i.price = variantPrice;
          changed = true;
        }
      });
      if (changed) { this.saveToStorage(); this.render(); }
    }

    render() {
      this.renderCards();
      this.renderProgress();
      this.renderTray();
    }

    renderCards() {
      if (!this.grid) return;
      const cards = this.grid.querySelectorAll('[data-fbb-card]');
      const self = this;
      const isFull = self.selection.length >= BUNDLE_SIZE;
      cards.forEach(function (card) {
        const productId = card.dataset.productId;
        const qty = self.getQty(productId);
        const isSelected = qty > 0;
        const needsPick = card.dataset.needsPick === 'true';

        card.classList.toggle(SELECTED_CLASS, isSelected);
        card.classList.toggle(LOCKED_CLASS, isFull && !isSelected);

        const numEl = card.querySelector('[data-fbb-num]');
        if (numEl) numEl.textContent = isSelected ? ('×' + qty) : '';

        const qtyEl = card.querySelector('[data-fbb-qty]');
        if (qtyEl) qtyEl.textContent = qty;
        const plusBtn = card.querySelector('[data-fbb-qty-plus]');
        if (plusBtn) plusBtn.disabled = isFull;

        if (needsPick) {
          const hasPicked = !!self.pendingVariants[productId] || isSelected;
          card.classList.toggle(HAS_VARIANT_CLASS, hasPicked);
          const action = card.querySelector('[data-fbb-action]');
          if (action) action.disabled = !hasPicked && !isSelected;

          if (isSelected) {
            const sel = self.selection.find(function (i) { return i.productId === productId; });
            const selectedVariantId = sel ? sel.variantId : null;
            const pills = card.querySelectorAll('[data-fbb-variant]');
            pills.forEach(function (p) {
              const active = p.dataset.variantId === selectedVariantId;
              p.classList.toggle('is-active', active);
              p.setAttribute('aria-checked', active ? 'true' : 'false');
            });
          }
        }
      });
    }

    renderProgress() {
      if (!this.progress) return;
      const n = this.selection.length;
      const isReady = n === BUNDLE_SIZE;

      if (this.countEl) {
        this.countEl.innerHTML = '<strong>' + n + '</strong> / ' + BUNDLE_SIZE + ' selected';
        this.countEl.classList.toggle('is-complete', isReady);
      }
      if (this.barFillEl) {
        this.barFillEl.style.width = (n / BUNDLE_SIZE * 100) + '%';
      }

      const totalCents = this.selection.reduce(function (sum, i) { return sum + i.price; }, 0);
      const finalCents = Math.round(totalCents * (1 - DISCOUNT_PCT / 100));
      const savedCents = totalCents - finalCents;

      if (this.amountOriginalEl) {
        this.amountOriginalEl.textContent = n > 0 ? this.formatMoney(totalCents) : '';
        this.amountOriginalEl.style.display = n > 0 && isReady ? 'inline' : 'none';
      }
      if (this.amountFinalEl) {
        this.amountFinalEl.textContent = this.formatMoney(isReady ? finalCents : totalCents);
      }
      if (this.amountSavedEl) {
        if (isReady) {
          this.amountSavedEl.textContent = 'You save ' + this.formatMoney(savedCents);
        } else {
          this.amountSavedEl.textContent = (BUNDLE_SIZE - n) + ' more for -' + DISCOUNT_PCT + '%';
        }
        this.amountSavedEl.style.display = 'block';
      }
      if (this.ctaEl) {
        this.ctaEl.classList.toggle('is-ready', isReady);
        this.ctaEl.disabled = !isReady;
        this.ctaEl.textContent = isReady ? ('Add bundle — save ' + DISCOUNT_PCT + '%') : ('Pick ' + (BUNDLE_SIZE - n) + ' more');
      }
    }

    renderTray() {
      if (!this.trayInnerEl) return;
      let html = '';
      for (let i = 0; i < BUNDLE_SIZE; i++) {
        const item = this.selection[i];
        if (item) {
          html += '<div class="fbb-tray__slot is-filled"><img src="' + item.image + '" alt="' + this.escape(item.title) + '" loading="lazy"><button type="button" class="fbb-tray__slot-remove" data-fbb-tray-remove data-variant-id="' + item.variantId + '" aria-label="Remove">×</button></div>';
        } else {
          html += '<div class="fbb-tray__slot"></div>';
        }
      }
      this.trayInnerEl.innerHTML = html;
    }

    addAllToCart() {
      if (this.selection.length !== BUNDLE_SIZE) return;
      if (this.ctaEl) this.ctaEl.classList.add('is-loading');
      const qtyByVariant = {};
      this.selection.forEach(function (i) {
        const vid = parseInt(i.variantId, 10);
        qtyByVariant[vid] = (qtyByVariant[vid] || 0) + 1;
      });
      const items = Object.keys(qtyByVariant).map(function (vid) {
        return { id: parseInt(vid, 10), quantity: qtyByVariant[vid], properties: { '_fair_bundle': 'pick-' + BUNDLE_SIZE } };
      });
      const self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (resp) {
        if (!resp.ok) return resp.json().then(function (err) { throw new Error(err.description || err.message || 'Add to cart failed'); });
        return resp.json();
      })
      .then(function () {
        self.selection = [];
        self.pendingVariants = {};
        self.saveToStorage();
        self.render();
        if (self.ctaEl) self.ctaEl.classList.remove('is-loading');
        self.openCartDrawer();
        self.refreshCartDrawerSection();
      })
      .catch(function (e) {
        self.showToast(e.message || 'Something went wrong. Try again.', 'warning');
        if (self.ctaEl) self.ctaEl.classList.remove('is-loading');
      });
    }

    refreshCartDrawerSection() {
      return fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          try {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const newDrawer = tmp.querySelector('cart-drawer') || tmp.querySelector('#cart-drawer');
            const oldDrawer = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
            if (newDrawer && oldDrawer) {
              oldDrawer.innerHTML = newDrawer.innerHTML;
              oldDrawer.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
          } catch (e) {}
        })
        .catch(function () {});
    }

    openCartDrawer() {
      ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (ev) {
        document.documentElement.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      const drawer = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        try { drawer.show(); return; } catch (e) {}
      }
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); return; } catch (e) {}
      }
      const toggle = document.querySelector('[aria-controls="cart-drawer"]') ||
                     document.querySelector('button[data-cart-drawer-toggle]') ||
                     document.querySelector('[data-cart-toggle]');
      if (toggle) {
        try { toggle.click(); return; } catch (e) {}
      }
      this.showToast('Bundle added — tap the cart icon to checkout.', 'warning');
    }

    applyFilter(activePill) {
      const filterValue = activePill.dataset.fbbFilter;
      this.filterPills.forEach(function (p) { p.classList.toggle('is-active', p === activePill); });
      if (!this.grid) return;
      const cards = this.grid.querySelectorAll('[data-fbb-card]');
      cards.forEach(function (card) {
        if (filterValue === 'all') { card.style.display = ''; return; }
        const cols = (card.dataset.collections || '').toLowerCase().split('|').filter(Boolean);
        card.style.display = cols.indexOf(filterValue.toLowerCase()) >= 0 ? '' : 'none';
      });
    }

    showToast(message, variant) {
      if (!this.toast) return;
      this.toast.textContent = message;
      this.toast.className = 'fbb-toast is-visible';
      if (variant) this.toast.classList.add('is-' + variant);
      clearTimeout(this._toastTimer);
      const self = this;
      this._toastTimer = setTimeout(function () {
        self.toast.classList.remove('is-visible');
      }, 2500);
    }

    formatMoney(cents) {
      const value = cents / 100;
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency', currency: this.currency,
          minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(value);
      } catch (e) { return '$' + value.toFixed(0); }
    }

    escape(str) {
      const div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML.replace(/"/g, '&quot;');
    }
  }

  function boot() {
    const root = document.querySelector('[data-fbb-root]');
    if (!root) return;
    const bs = parseInt(root.dataset.bundleSize, 10);
    const dp = parseInt(root.dataset.discountPct, 10);
    if (bs > 0) BUNDLE_SIZE = bs;
    if (dp > 0) DISCOUNT_PCT = dp;
    new BundleBuilder(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
